"use client";

import { cn } from "../../utils";
import { useCheckboxRootContext } from "./context";

export const IndeterminateIcon = () => {
  const { size, disabled } = useCheckboxRootContext();

  return size === "sm" ? (
    <svg
      className={cn("size-2", disabled ? "stroke-neutral-90" : "stroke-neutral-10")}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5.252 12h13.496" />
    </svg>
  ) : (
    <svg
      className={cn("size-3", disabled ? "stroke-neutral-90" : "stroke-neutral-10")}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5.252 12h13.496" />
    </svg>
  );
};
